/**
 * Utility functions for generating feedback form links
 */

/**
 * Gets the base URL for feedback forms (uses current domain)
 */
function getFeedbackDomain(): string {
  if (typeof window !== 'undefined') {
    return window.location.origin;
  }
  return 'https://sendfeedback.ai'; // Fallback for SSR
}

/**
 * Generates a feedback link in the format: yourdomain.com/COMPANY/FEEDBACKFORMNAME
 * Falls back to using user ID if company name is not available
 */
export function generateFeedbackLink(companyName: string | null | undefined, slug: string): string {
  // Sanitize company name for URL
  const sanitizedCompany = companyName 
    ? companyName.toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')
    : 'user';
  
  const domain = getFeedbackDomain();
  return `${domain}/${sanitizedCompany}/${slug}`;
}

/**
 * Gets the display version of the feedback link (without https://)
 */
export function getDisplayFeedbackLink(companyName: string | null | undefined, slug: string): string {
  const fullLink = generateFeedbackLink(companyName, slug);
  return fullLink.replace('https://', '');
}

/**
 * Gets the display version for URL preview (domain/company/slug)
 */
export function getFeedbackPath(companyName: string | null | undefined, slug: string): string {
  const sanitizedCompany = companyName 
    ? companyName.toLowerCase().replace(/[^a-z0-9-]/g, '-').replace(/-+/g, '-').replace(/^-|-$/g, '')
    : 'user';
  
  return `sendfeedback.ai/${sanitizedCompany}/${slug}`;
}
